export enum RefundStatus {
  Pending = 101,
  Approve = 102,
  Done = 500,
  Failed = 998,
  Canceled = 999,
}
